import React from "react";
import { Col, Row } from "react-bootstrap";
import "../../../stylesheets/components/Reports/SubscriptionFees/SubscriptionFees.scss";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import { subscriptionFeesTabs } from "./Constantsubscription";
import SubscriptionTabData from "./SubscriptionTabdata";
import Drawer from "react-bottom-drawer";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import CommonDownloadReport from "../CommonComponent/CommonDownloadReport";
import { ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import di from "@frameworks/web/components/Reports/SubscriptionFees/di/servicelocator";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { useDispatch, useSelector } from "react-redux";
import mainDI from "@frameworks/web/di/index";
import SmcasePopupLoaderMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoaderMob";
import SmcasePopupSuccessMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccessMob";
import SmcasePopupFailMob from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFailMob";
import FamilyTaggingMain from "../FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { useParams } from "react-router-dom";
const SubscriptionFeesMobile = (props) => {
    const device = DeviceContext();
    const dispatch = useDispatch();
    const { loginSource } = useParams();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const [downloadReport, setDownloadReport] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [operation, setOperation] = React.useState();
    const [downloadCheck, setDownloadCheck] = React.useState(false);
    const [emailCheck, setEmailCheck] = React.useState(false);
    const [showAllEmails, setShowAllEmails] = React.useState(false);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginSource !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const toggleShowAllEmails = () => {
        setShowAllEmails(!showAllEmails);
    };
    const loaderMessage = () => {
        if (downloadCheck && emailCheck)
            return "Download and Share";
        if (downloadCheck)
            return "download";
        if (emailCheck)
            return "share";
    };
    const FailureMessage = () => {
        if (downloadCheck && emailCheck)
            return "to download and share";
        if (downloadCheck)
            return "to download";
        if (emailCheck)
            return "to share";
    };
    const modalTitleDwnldEmail = () => {
        if (downloadCheck && emailCheck)
            return "Downloading and Sharing Subscription";
        if (downloadCheck)
            return "Download Subscription";
        if (emailCheck)
            return "Send Subscription";
    };
    const closeDrawerLoader = React.useCallback(() => setShowLoader(false), []);
    const openDrawerDownloadS = React.useCallback(() => setDownloadSuccess(true), []);
    const closeDrawerDownloadS = React.useCallback(() => setDownloadSuccess(false), []);
    const closeDrawerFail = React.useCallback(() => setDownloadFail(false), []);
    const downloadSuccessNode = () => {
        const emailList = di.subscriptionReport.emailList;
        if (downloadCheck && emailCheck) {
            return (React.createElement("div", { className: "DMSans_16_500 text-center txt_primaryGrey" },
                "Your Subscription Report is successfully Downloaded and also Shared with",
                " ",
                React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 || showAllEmails ? (emailList.map((item, index) => (React.createElement("div", { key: index }, index < emailList.length - 1 ? `${item}, ` : item)))) : (React.createElement(React.Fragment, null,
                    emailList.slice(0, 3).map((email) => (React.createElement("div", { key: email }, email))),
                    React.createElement("div", null,
                        "and",
                        " ",
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline", onClick: toggleShowAllEmails },
                            emailList.length - 3,
                            " More",
                            " ",
                            emailList.length - 3 === 1 ? "email" : "emails")))))));
        }
        if (downloadCheck) {
            return (React.createElement("div", { className: "DMSans_16_500 text-center txt_primaryGrey" }, "Your Subscription Fees Report is successfully downloaded"));
        }
        if (emailCheck) {
            return (React.createElement("div", { className: "DMSans_16_500 text-center txt_primaryGrey" },
                "Your Subscription Fees Report is successfully shared with",
                " ",
                React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 || showAllEmails ? (emailList.map((item, index) => (React.createElement("div", { key: index }, index < emailList.length - 1 ? `${item}, ` : item)))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", null, emailList.slice(0, 3).join(", ")),
                    React.createElement("div", null,
                        "and",
                        " ",
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline", onClick: toggleShowAllEmails },
                            emailList.length - 3,
                            " More",
                            " ",
                            emailList.length - 3 === 1 ? "email" : "emails")))))));
        }
    };
    const downloadEmailFile = (email, download) => {
        setShowLoader(true);
        setDownloadReport(false);
        if (email)
            email.accodes = props === null || props === void 0 ? void 0 : props.accCode;
        if (download)
            download.accodes = props === null || props === void 0 ? void 0 : props.accCode;
        di.subscriptionReport
            .downloadAndSendSubsReport(email, download, props.selectedTab)
            .then((resp) => {
            if (resp)
                setShowLoader(false);
            setDownloadSuccess(resp);
        })
            .catch((err) => {
            setDownloadFail(true);
            setShowLoader(false);
        });
    };
    React.useEffect(() => {
        if ((device === null || device === void 0 ? void 0 : device.isDesktop) && (device === null || device === void 0 ? void 0 : device.isDesktop))
            mainDI.header.RemoveHeaderData(true);
        else
            mainDI.header.RemoveHeaderData(false),
                dispatch(mainDI.footer.updateShowMob_Menu(false));
    }, [device]);
    React.useEffect(() => {
        setShowAllEmails(false);
    }, [di.subscriptionReport.emailList]);
    return (React.createElement("div", { className: "Subscriptionfees_mobile mb-genericSidebar common-reports-download-mail addFamily-modal-mob" },
        React.createElement(Row, { className: "Subscriptionicon mx-0 px-15" },
            React.createElement(Col, { lg: 12, className: "mgt-23 d-flex align-items-center d-flex justify-content-between px-0" },
                React.createElement("span", { className: "DMSansBold_20_700 txt-midnight-blue" },
                    "Subscription ",
                    React.createElement("span", { className: "DMSansNormal_20_400" }, "Fees")),
                React.createElement("span", { className: "common-info-icon ps-2" }))),
        React.createElement("div", { className: "pt-10" },
            React.createElement(FamilyTaggingMain, { hideConsolidated: false, oldTheme: true })),
        React.createElement(Row, { className: "mgt-25 mx-0 px-15" },
            React.createElement(Col, { lg: 6, className: "d-center-end common-download-mb gap-10 px-0" },
                React.createElement("div", { className: "common-download" },
                    React.createElement("button", { className: `download-btn `, onClick: () => {
                            setDownloadReport(true);
                        }, disabled: props.disableDownload() },
                        React.createElement("i", { className: "edel-icon-download-coloured" },
                            React.createElement("span", { className: "path1" }),
                            React.createElement("span", { className: "path2" })))))),
        React.createElement(Row, { className: "subscription_row_tabs mx-0 px-0" },
            React.createElement("div", { className: "col-lg-12 px-15" },
                React.createElement(GenericTabs, { defaultActiveKey: props.selectedTab, tabsArray: subscriptionFeesTabs.map((tab) => {
                        return {
                            title: tab.title,
                            eventKey: tab.eventKey,
                            tabContent: React.createElement(SubscriptionTabData, { type: props.selectedTab }),
                        };
                    }), externalClassName: "subscriptionfeebordermobile common-tab-color", callBackFunction: props.handleTabSelect }))),
        React.createElement("div", { className: `common-mob-smallcase-popup-download ${!isClientLogin && "not-client-login"} mb-genericSidebar` },
            React.createElement(GenericDrawer, { show: downloadReport, setShow: setDownloadReport, parentClass: "z-index-high  new-background-blur bg_aqua_white  commonnew-download-report-drawer", headerComp: React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSanN_16_400 txt-midnight-blue px-3" }, "Download Report")), bodyComp: React.createElement(React.Fragment, null,
                    React.createElement(CommonDownloadReport, { setDownloadSuccess: setDownloadSuccess, setShowLoader: setShowLoader, setDownloadFail: setDownloadFail, showLoader: showLoader, downloadSuccess: downloadSuccess, downloadFail: downloadFail, PDF_or_Excel: ReportType.PDF, setOperation: setOperation, operation: operation, submitDownload: downloadEmailFile, dateRequired: true, setEmailCheck: setEmailCheck, setDownloadCheck: setDownloadCheck, messageReactNode: downloadSuccessNode(), goBack: () => setDownloadReport(false) })) }),
            React.createElement(Drawer, { isVisible: showLoader || downloadSuccess || downloadFail, onClose: () => {
                    closeDrawerLoader();
                    closeDrawerDownloadS();
                    closeDrawerFail();
                }, duration: 250, hideScrollbars: true, className: "drawer__handle-wrapper z-index-high" },
                showLoader && (React.createElement(SmcasePopupLoaderMob, { Title: modalTitleDwnldEmail(), closeDrawer: closeDrawerLoader, message: `Your Subscription Fees Report is getting prepared to ${loaderMessage()}` })),
                downloadSuccess && (React.createElement(SmcasePopupSuccessMob, { messageReactNode: downloadSuccessNode(), Title: modalTitleDwnldEmail(), closeDrawer: closeDrawerDownloadS, operation: operation, isDownloadIcon: true, sendBack: true, goBackText: true, goBack: () => setDownloadReport(false) })),
                downloadFail && (React.createElement(SmcasePopupFailMob, { closeDrawer: closeDrawerFail, operation: operation, goBack: () => setDownloadReport(false), sendBack: true, goBackText: true, message: `<span class='DMSans_16_500'>We ran into some technical  difficulties,<br> please try ${FailureMessage()} the report again!</span>` }))))));
};
export default SubscriptionFeesMobile;
